import openSocket from "socket.io-client";
import { isObject } from "lodash";
import SocketWorker from "./SocketWorker"

export function socketConnection(params) {
  let userId = localStorage.getItem("userId") || "";
  let companyId = "";

  if (isObject(params) && params?.user) {
    companyId = params?.user?.companyId
    userId = String(params?.user?.id || "")

    if (userId) {
      localStorage.setItem("userId", userId)
    }
  }
 
  return SocketWorker(companyId,userId)
}